import ClaimLieCard from "@components/claimLieCard";
import ImageContainer from "@components/imageContainer";
import InsuranceLieCard from "@components/insuranceLieCard";
import LieCard from "@components/lieCard";
import { executeActions } from "@utils/index";
import { resolvePath } from "@utils/resolvePath";
import { useOnload } from "@utils/useOnLoad";
import DealershipLieCard from "@widgets/DealershipLieCard";
import React from "react";
import { GridContainer, Header, Lie1, Lie2, Lie3, Lie4 } from "./styles";

// The main React component
const DealershipLiesGrid = (props: any) => {
  const {
    is_visible = true,
    dealershipLiesheading,
    dealershipLiesList
  } = props;
  const { actions } = props;
  const { on_load } = actions || {};
  useOnload({ on_load });
  const { lie1, lie2, lie3, lie4 } = dealershipLiesList;
  const { lie1OnClick, lie2OnClick } = actions;
  const handelie1Click = () => {
    executeActions(lie1OnClick);
  };
  const handlelie2Click = () => {
    executeActions(lie2OnClick);
  };

  return (
    <>
      {is_visible && (
        <GridContainer>
          <Header dangerouslySetInnerHTML={{ __html: dealershipLiesheading }} />
          <Lie1>
            <DealershipLieCard
              dealershipLieNumber={`#Myth ${lie1.lieNumber}`}
              dealershipLieQuote={lie1.heading}
              dealershipLieMainText={lie1.description}
              onDealershipLieCardClick={handelie1Click}
            />
          </Lie1>
          <Lie2>
            <InsuranceLieCard
              lieNumber={`#Myth ${lie2.lieNumber}`}
              lieQuote={lie2.heading}
              mainText={lie2.description}
              subText={lie2.buttonText}
              onInsuranceLieCardClick={handlelie2Click}
            />
          </Lie2>
          <Lie3>
            <ClaimLieCard
              is_visible={true}
              lieNumber={`#Myth ${lie3.lieNumber}`}
              lieQuote={lie3.heading}
              bulletPoints={lie3.description}
              videoSrc={lie3.videoSrc || "/videos/testVideo.mp4"}
            />
          </Lie3>
          <Lie4>
            <LieCard
              lieNumber={`#Myth ${lie4.lieNumber}`}
              lieQuote={lie4.heading}
              mainText={lie4.description}
              subText={lie4.buttonText}
            />
          </Lie4>
        </GridContainer>
      )}
    </>
  );
};

export default DealershipLiesGrid;
